<template>
	
<div class="risk" v-if="rawScore !== 0">

	<div class="risk-title">{{ section.treatment.more.risk.title }}</div>

	<div class="risk-toggle">

		<div class="risk-toggle-text">{{ section.treatment.more.risk.text }}</div>
		
		<div class="risk-toggle-input">

			<div class="risk-toggle-input-item" :class="{'is-active': type === 'major'}" v-on:click="onToggleClick('major')">Major</div>
			<div class="risk-toggle-input-item" :class="{'is-active': type === 'hip'}" v-on:click="onToggleClick('hip')">Hip</div>

		</div>

	</div>

	<div class="risk-values">

		<div class="risk-values-item">

			<div class="risk-values-item-text">Without Osteoporosis Medicine</div> 
			<div class="risk-values-item-score">{{ score }} in 100</div> 

			<com-cates v-if="expand" :max="100" :bad="score" action="break a bone" class="risk-values-item-cates" />

		</div>

		<div class="risk-values-item">

			<div class="risk-values-item-text">With Osteoporosis Medicine</div> 
			<div class="risk-values-item-score">{{ adjustedScore }} in 100</div> 

			<com-cates v-if="expand" :max="100" :bad="adjustedScore" :change="score - adjustedScore" action="break a bone" class="risk-values-item-cates" />

		</div>

	</div>

	<div class="risk-expand">

		<com-next v-on:click.native="onExpandClick" :dark="true" color="grey" icon="graph" :text="(expand) ? 'hide graphs' : 'view graphs'" />

	</div>

</div>

</template>

<script>

import comNext from '../../../common/Next'
import comCates from '../../../common/Cates'

export default {

	props: ['section', 'treatment'],

	components: {
		'com-next': comNext,
		'com-cates': comCates
	},

	data: function() {

		return {
			type: 'major',
			expand: false
		}

	},

	computed: {

		rawScore: function() {

			return this.frax(this.type)

		},

		score: function() {

			return Math.round(this.rawScore)

		},

		adjustedScore: function() {

			return Math.round(this.rawScore * (1 - (this.section.treatment[this.treatment].reduce[this.type] / 100)))

		}

	},

	methods: {

		onExpandClick: function() {

			this.expand = !this.expand

		},

		onToggleClick: function(type) {

			this.type = type

		}

	}

}

</script>

<style scoped>

.risk {
	background-color: #fff;
	padding: 32px;
	border-radius: 17px;
	margin-bottom: 16px;
}

.risk-title {
	color: #343434;
	font-size: 24px;
	margin-bottom: 32px;
	font-weight: 600;
}

.risk-toggle {
	display: flex;
	margin-bottom: 32px;
}

.risk-toggle-text {
	color: #343434;
	font-weight: 300;
	font-size: 18px;
	line-height: 48px;
	flex-grow: 1;
}

.risk-toggle-input {
	flex-shrink: 0;
	display: flex;
}

.risk-toggle-input-item {
	border: 2px solid #F8A533;
	background-color: #fff;
	color: #343434;
	font-size: 18px;
	line-height: 44px;
	font-weight: 600;
	width: 120px;
	text-align: center;
	padding: 0px 32px;
	cursor: pointer;
	transition: all 100ms linear;
}

.risk-toggle-input-item:hover:not(.is-active) {
	background-color: #F8A533;
	color: #fff;
}

.risk-toggle-input-item.is-active {
	background-color: #343434;
	border-color: #343434;
	color: #fff;
}

.risk-toggle-input-item:first-child {
	border-radius: 17px 0px 0px 17px;
	border-right-width: 0px;;
}

.risk-toggle-input-item:last-child {
	border-radius: 0px 17px 17px 0px;
	border-left-width: 0px;;
}

.risk-values {
	display: flex;
	margin-bottom: 32px;
}

.risk-values-item {
	width: 50%;
	text-align: center;
}

.risk-values-item-text {
	color: #343434;
	font-size: 16px;
	margin-bottom: 16px;
	font-weight: 600;
}

.risk-values-item-score {
	color: #343434;
	font-size: 35px;
	font-weight: 600;
}

.risk-values-item-cates {
	margin: 0px auto;
	margin-top: 32px;
}

.risk-expand {
	display: flex;
	justify-content: flex-end;
}

</style>